//! Order is Important if Other Services Dependes On it */
//! Primary Services Add Here
import registerIncludes from "@/services/includes"; // components that we want to register globally

export default (app) => {
  // register the includes globally
  registerIncludes(app);
};
